import building from './building'
import tooltipBuilding from './tooltipBuilding'
import cities from './cities'
import regions from './regions'
import exportCSV from './exportCSV'

export default { building, cities, regions, exportCSV, tooltipBuilding }
